import { DomainButton } from "./DomainButton";
import { NavLink } from "react-router-dom";

export function ButtonLink({ to, children }) {
  return <NavLink to={to}>
    <DomainButton >
      {children}
    </DomainButton>
  </NavLink>;
}